import { createReducer, on } from '@ngrx/store';
import { FeatureToggle } from 'src/app/feature-toggle/interfaces/feature-toggles';
import { FeatureToggleState } from '../feature-toggle.state';
import { SetFeatureToggle } from '../actions/feature-toggle.action';

const initialType: FeatureToggleState = {
  featureToggles: null,
};

export const featureToggleActionReducer = createReducer(
  initialType,
  on(SetFeatureToggle, (state, { featureToggles }): { featureToggles: FeatureToggle[] } => ({
    ...state,
    featureToggles: featureToggles.featureToggles,
  })),
);
